import Vue from "vue";
import Vuex from "vuex";
import modules from "./modules";
import persistences from "./persistences";

Vue.use(Vuex);

export default new Vuex.Store({
  modules,
  plugins: [...persistences],
});
